import { Injectable } from '@angular/core';
import { FilterService } from '@shared/models/filter-service.model';
import { Observable, Subject } from 'rxjs/Rx';
import { DossierWorkingFilterModel } from '../models/dossier-working-filter.model';

@Injectable({
    providedIn: 'root'
})
export class DossierWorkingFilterService implements FilterService {

	private filterSubject = new Subject<DossierWorkingFilterModel>();
	private filterObservable$ = this.filterSubject.asObservable();

	private currentFilter: DossierWorkingFilterModel;
	private lastFilter: DossierWorkingFilterModel;

	getCurrentFilter(): DossierWorkingFilterModel {
		return this.currentFilter;
	}

	getEmptyFilter(): DossierWorkingFilterModel {
		return this.currentFilter = new DossierWorkingFilterModel();
	}

	getFilterObservable(): Observable<DossierWorkingFilterModel> {
		return this.filterObservable$;
	}

	reloadLastFilter() {
		this.updateFilter(this.lastFilter);
	}

	updateFilter(filter: DossierWorkingFilterModel) {
		this.currentFilter = filter;
		this.filterSubject.next(filter);
		if (this.currentFilter !== null) {
			this.lastFilter = this.currentFilter;
		}
	}
}
